import { GridColDef, GridRowsProp } from '@mui/x-data-grid';
import { useContext, useEffect, useState } from 'react';
import { AppContext } from '../../app-context';
import IGridComponent from '../../components/grid/i-grid.component';
import TitlePanel from '../../components/title-panel/title-panel.component';
import { EMPTY_STRING, PAGE_SIZE } from '../common/constants';
import { formatDateLong, isEmptyArray } from '../common/util.services';
import './logging.component.scss';
import { getLogs } from './logging.services';
import ISearchField from '../../components/text-component/search-field/i-searchfield.component';

const Logging = () => {
  const appContext = useContext(AppContext);
  const rows: GridRowsProp = [];
  const [loggingData, setLoggingData] = useState(rows);
  const [searchText, setSearchText] = useState(EMPTY_STRING);
  const columns: GridColDef[] = [
    { field: 'date', headerName: 'Date', filterable: false, sortable: false, editable: false,
      valueFormatter: (date: any) => formatDateLong(date), width: 180 
    },
    { field: 'service', headerName: 'Service', filterable: false, sortable: false, editable: false, width: 280 },
    { field: 'parameters', headerName: 'Parameters', filterable: false, sortable: false, editable: false, width: 750 },
    { field: 'name', headerName: 'Name', filterable: false, sortable: false, editable: false, width: 150 },
    ];
  const [loading, setLoading] = useState(true);
  const [page, setPage] = useState(0);
  const [pageSize, setPageSize] = useState(PAGE_SIZE);
  const [totalRows, setTotalRows] = useState(0);

  useEffect(() => {
    if (isEmptyArray(rows)) {
      setLoading(true);
      getLogs(searchText, page, pageSize, appContext,
        (response: any) => {
          setLoggingData(response.data.data);
          setTotalRows(response.data.totalElements);
          appContext.setShowLoader(false);
          setLoading(false);
        }, (error: any) => {
          console.log(error);
          appContext.setShowLoader(false);
          appContext.setErrorMessage(error.message);
          setLoading(false);
        });
    }
  }, [searchText, page, pageSize]);

  const onPaginationModelChange = (evt: any) => {
    setPage(evt.page);
    setPageSize(evt.pageSize);
  }

  const search = (e: any) => {
    setSearchText(e);
  }

  const getMainPanel = () => {
    return <>
      <ISearchField onActionEvent={search} />
      <IGridComponent title={''} rows={loggingData} columns={columns} loading={loading}
        paginationType="server" paginationModelChange={onPaginationModelChange} totalRows={totalRows}
        showAction={false} showAddBtn={false} getRowId={(row: any) => row.rowId} maxHeight={500}/>
    </>
  }

  return <TitlePanel title='Logging' panelBody={getMainPanel()} />
}

export default Logging;